import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UIEffect } from './portfolio-managers.effects';
import { STORE_TYPE } from './portfolio-managers.model';
import { uiReducer } from './portfolio-managers.reducer';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature(STORE_TYPE, uiReducer), EffectsModule.forFeature([UIEffect])],
  exports: [],
})
export class UIPortfolioManagersStoreModule {}
